import React, { useEffect, useState } from "react";
import "./nav.css";
import logo from "../../assets/home-logo.png";
import { Btn } from "../../utils/utils";
import { CloseCircle, HambergerMenu } from "iconsax-react";
import Overlay from "../overlay/Overlay";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Nav = () => {
  
  const pathname = useLocation().pathname;
  const navigate = useNavigate();
  const [active, setActive] = useState("");

  const user = JSON.parse(localStorage.getItem("apk"));

  useEffect(() => {
    setActive(pathname);
  }, [pathname])
  

  const navLinks = [
    {
      title: "Residential",
      link: "/residential",
    },
    {
      title: "Commercial",
      link: "/commercial",
    },
    {
      title: "Landlord",
      link: "/agents",
    },
    {
      title: "Developers",
      link: "/developers",
    },
  ];

  const [showMenu, setShowMenu] = useState(false);

  const clickMenu = (link) => {
    if(link){
      navigate(link);
    }
    setShowMenu(!showMenu);
  }

  return (
    <nav className="nav-cont">
      {showMenu && <Overlay />}
      <div className="nav-web">
        <div className="nav-logo">
        <Link to={"/"} style={{textDecoration: "none"}}><img src={logo} alt="logo" /></Link>
        </div>
        <div className="nav-links">
          {navLinks?.map((item, idx) => {
            return (
              <Link key={idx} to={item.link} style={{textDecoration: "none"}}><p className="each-link" style={{color: active === item.link && "#f08228"}}>
                {item.title}
              </p></Link>
            );
          })}
          {/* <Btn
            btnText={"Post Property"}
            btnClass={"home-btn_trans"}
            btnLink={"/agent/property/add"}
          /> */}
          {user && <Btn
            btnText={"Go to Dashboard"}
            btnClass={"home-btn_trans"}
            btnLink={user?.data?.accountType === "Agent" && "/agent/overview"}
          />}
          {!user && <><Btn
            btnText={"Sign Up"}
            btnClass={"home-btn_trans"}
            btnLink={"/auth/signup-opt"}
          />
          <Btn btnText={"Sign In"} btnClass={"home-btn"} btnLink={"/auth/signin"} /></>}
        </div>
      </div>
      <div className="nav-mobile">
        <div className="nav-logo">
          <Link to={"/"} style={{textDecoration: "none"}}><img src={logo} alt="logo" /></Link>
        </div>
        <HambergerMenu size={24} color="#080B24" cursor={"pointer"} onClick={() => clickMenu("")} />
        {showMenu && <div className="mobile-menu">
          <div className="menu-close">
            <CloseCircle size={32} color="#080B24" cursor={"pointer"} onClick={() => clickMenu("")} />
          </div>
        <div className="nav-logo">
        <img src={logo} alt="logo" onClick={() => clickMenu("/")} />
        </div>
          <div className="nav-links">
            {navLinks?.map((item, idx) => {
              return (
                <Link key={idx} to={item.link} style={{textDecoration: "none"}}><p className="each-link" style={{color: pathname === item.link && "#f08228"}} onClick={()=> clickMenu("")}>
                  {item.title}
                </p></Link>
              );
            })}

            {/* <div className="btn-cont">
              <Btn
                btnText={"Post Property"}
                btnClass={"home-btn_trans"}
                // btnLink={"/"}
                btnWidth={"100%"}
                btnClick={() => clickMenu("/agent/property/add")}
              />
            </div> */}
          {user && <div className="btn-cont"> <Btn
            btnText={"Go to Dashboard"}
            btnClass={"home-btn_trans"}
            btnLink={user?.data?.accountType === "Agent" && "/agent/overview"}
          /> </div>}
            {!user && <><div className="btn-cont">
              <Btn
                btnText={"Sign Up"}
                btnClass={"home-btn_trans"}
                // btnLink={"/auth/signup-opt"}
                btnWidth={"100%"}
                btnClick={() => clickMenu("/auth/signup-opt")}
              />
            </div>

            <div className="btn-cont">
              <Btn
                btnText={"Sign In"}
                btnClass={"home-btn"}
                // btnLink={"/"}
                btnWidth={"100%"}
                btnClick={() => clickMenu("/auth/signin")}
              />
            </div></>}
          </div>
        </div>}
      </div>
    </nav>
  );
};

export default Nav;
